import ResizedImage from 'shared/components/resized-image/resized-image';

const _propTypes = {
  thumbnailUrl: React.PropTypes.string.isRequired,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string,
};

const _defaultProps = {
  width: 160,
  height: 104,
};


export default class SimpleThumbnail extends React.Component {
  static propTypes = _propTypes;
  static defaultProps = _defaultProps;

  render() {
    const { thumbnailUrl, className } = this.props;
    const size = _.pick(this.props, 'width', 'height');

    return (
      <ResizedImage src={thumbnailUrl}
                    className={className}
                    {...size} />
    );
  }
}

export class SimpleVideoThumbnail extends React.Component {

  static propTypes = {
    video: React.PropTypes.object.isRequired,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    className: React.PropTypes.string,
  };
  static defaultProps = _defaultProps;

  render() {
    const { video: { coverUrl, customCoverUrl }, width, height, className } = this.props;

    return (
      <SimpleThumbnail thumbnailUrl={customCoverUrl || coverUrl}
                       className={className}
                       width={width}
                       height={height} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/thumbnail/simple.js